module.exports = __webpack_public_path__ + "img/list.947e8747.jpg";